//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import dialogbox from '@/components/ui/dialogbox';
import inputbox from '@/components/ui/inputbox';
import cardbox from '@/components/ui/cardbox';
import buttonbox from '@/components/ui/buttonbox';

export default {
    components: {
        cardbox,dialogbox,inputbox,buttonbox
    },
    data() {
        return {
            dialogName: {
                title: '选择收货地址',
                show: false,
                type: '',
                style: 'margin-top:6rem; background: rgba(255, 255, 255, 0.9);',
            },
            addrList: [],
        };
    },
    methods: {

        // 设置为默认
        setDefault(item){

            item.is_default = 1;
            item.print_addr = item.print_addr || "0";

            const opts = {
                url: api.myAddressMod,
                data: {
                    ...item
                },
                type: 'put'
            }

            common.query(opts).then(res=>{
                this.queryAddrList();
            },res=>{
                this.$vux.toast.text(res.message)
            })
        },

        // 删除地址
        delAddress(item){

            const _this = this;
            const opts = {
                url: api.myAddressDel,
                data: {
                    addr_id: item.addr_id,
                },
                type: 'delete'
            }

            this.$vux.confirm.show({
                title: '删除确认',
                onConfirm () {
                    common.query(opts).then(res=>{
                        _this.queryAddress();
                    },res=>{
                        _this.$vux.toast.text(res.message)
                    })
                }
            })
        },

        //跳转详情页
        goAddress(id) {
            this.$router.push("/member/address");
        },

        // 查询地址列表
        queryAddrList() {
            let opts = {
                url: api.myAddress,
                data: {},
                type: "get",
            };
            common.query(opts).then((res) => {
                this.addrList = res.data;
                this.setAddress(res.data)
            },(res) => {
                this.$vux.toast.text(res.message);
            });
        },

        // 设置地址列表
        setAddress(data) {

            if(data.length<1) return;

            let nAddr = data.filter(val=>val.is_default&&val)[0];
           
            if(!nAddr || !nAddr.addr_id){
                this.$emit('onchange');
                return;
            } 

            let opts = {
                url: api.myAddressSet,
                data: {id:nAddr.addr_id},
                type: "put",
            };
            common.query(opts).then((res) => {
                this.$emit('onchange');
                console.log(res.data)
            },(res) => {
                this.$vux.toast.text(res.message);
            });
        },


    },
    mounted() {
        this.queryAddrList();
    },
};



// WEBPACK FOOTER //
// ./src/views/pages/home/addressDialog.vue